import Header from './components/Header';
import Hero from './components/Hero';
import TrendRank from './components/TrendRank';
import TopicWall from './components/TopicWall';
import FeaturedRoundups from './components/FeaturedRoundups';
import RoundupGrid from './components/RoundupGrid';
import DigestTimeline from './components/DigestTimeline';
import ThemeLibrary from './components/ThemeLibrary';
import SubscribeCta from './components/SubscribeCta';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <TrendRank />
        <TopicWall />
        <FeaturedRoundups />
        <RoundupGrid />
        <DigestTimeline />
        <ThemeLibrary />
        <SubscribeCta />
      </main>
      <Footer />
    </div>
  );
}